import {
  UPDATE_PCON_URL,
} from '../Actions/Pcon.action';

const defaultState = {
  url: '',
}

export const pcon = (state = defaultState, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_PCON_URL:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
}
